<template>
	<ld-popup
		id="popup-adicionar-prazo"
		class="popup-prazo"
		:fullscreen="true"
		:active.sync="activePopup"
		:button-close-hidden="true"
		:disabledBackgoundClose="true"
		:closed="funcaoFechar"
	>
		<div class="flex justify-between w-full p-2 pb-5">
			<div class="flex items-center">
				<div class="content-title flex flex-col items-start ">
					<h2 class="title">Adicionar prazo</h2>
					<div v-if="empresa && empresa.nome" class="flex items-center">
						<h4 class="text-sm">{{ empresa.nome }}</h4>
					</div>
				</div>
			</div>
			<ld-button
				icon-pack="feather"
				icon="icon-x"
				size="large"
				color="dark"
				type="flat"
				class="header-button-close ml-4"
				@click="popupCancelarCadastro = true"
			></ld-button>
		</div>

		<vx-card>
			<form
				id="form-adicionar-prazo"
				class="py-5 md:px-4"
			>
					<!-- GENERAL -->
				<geral
					parent="#popup-adicionar-prazo"
					v-if="activePopup"
					:titulo.sync="prazo.titulo"
					:acao.sync="prazo.acao"
					:responsavel.sync="responsavelPk"
					:supervisor.sync="supervisorPk"
					:prioridade.sync="prazo.prioridade"
					:ciencia.sync="prazo.ciente"
					:descricao.sync="prazo.descricao"
					:prazoDesativado="false"
					:prazoFinalizado="false"
					:prazoPerdido="false"
				/>

				<anexos
					v-if="activePopup && ($permissions.can('anexoadicionar') || $permissions.can('autenticadosuperuser'))"
					:anexos.sync="prazo.anexos"/>

				<datas
					:dateInicio.sync="prazo.dataInicio"
					:dateFim.sync="prazo.dataFim"
					:quantidadeDias.sync="prazo.quantidadeDias"
					:tipoCalculo.sync="prazo.diasUteis"
					:prazoDesativado="false"
					:prazoFinalizado="false"
					:prazoPerdido="false"
				/>


				<partes
					:prazoFinalizado="false"
					:prazoDesativado="false"
					:prazoPerdido="false"
					:partes.sync="prazo.partes"
				/>

				<div class="flex justify-end py-5">
					<ld-button
						type="border"
						class="mr-4"
						@click="popupCancelarCadastro = true"
					>
						Cancelar
					</ld-button>
					<ld-button @click="adicionarPrazo">
						Adicionar prazo
					</ld-button>
				</div>
			</form>
		</vx-card>

		<ld-popup
			title="Cancelar cadastro?"
			:active.sync="popupCancelarCadastro"
			:button-close-hidden="true"
		>
			<p>
				Tem certeza que deseja cancelar o cadastro do prazo? Se
				cancelar, todos os dados inseridos serão perdidos.
			</p>

			<vs-divider />

			<div class="button-container">
				<div class="button-group flex justify-end">
					<ld-button
						buttonType="submit"
						class="w-20 mr-4"
						color="danger"
						type="filled"
						@click="cancelarCadastro"
						>Cancelar cadastro</ld-button
					>

					<ld-button
						class="w-15"
						color="dark"
						type="flat"
						@click="popupCancelarCadastro = false"
						>Voltar</ld-button
					>
				</div>
			</div>
		</ld-popup>

		<ld-popup
				title="Prazo adicionado"
				:active.sync="popupPrazoAdicionado"
				:button-close-hidden="true"
				:disabledBackgoundClose="true"
			>
				<p>
					O prazo foi adicionado.
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<vs-button
							class="w-32"
							color="primary"
							type="filled"
							@click="cadastroFinalizado"
							>OK</vs-button
						>
					</div>
				</div>
			</ld-popup>
	</ld-popup>
</template>

<script>

import Geral from "../../prazo/geral/Geral";
import Datas from "../../prazo/datas/Datas";
import Partes from "../../prazo/partes/Partes";
import Anexos from "../../prazo/anexos/Anexos";
import Prazo from '../../../../../../models/Prazo';
import Usuario from '../../../../../../models/Usuario';
import ErrorHelper from '../../../../../../helpers/ErrorHelper';
import Empresa from '../../../../../../models/Empresa';

export default {
	name: "PopupAdicionarPrazo",
	data() {
		return {
			empresa: null,
			prazo: new Prazo({
				responsavel: new Usuario({}),
				supervisor: new Usuario({}),
				partes: [],
				anexos: [],
				ciente: false,
				prioridade: false,
				diasUteis: "false",
			}),
			popupPrazoAdicionado: false,
			popupCancelarCadastro: false,
		};
	},
	components: {
		Geral,
		Datas,
		Partes,
		Anexos
	},
	props: {
		active: {
			type: Boolean,
			default: false
		},
		closed: {
			type: Function,
			required: false
		},
		prazoCopy: {
			type: Object,
			required: false,
		}
	},
	computed: {
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		activePopup: {
			set(value) {
				this.$emit("update:active", value);
			},
			get() {
				return this.active;
			}
		},
		responsavelPk: {
			get() {
				if (!this.prazo || !this.prazo.responsavel) {
					return null;
				}
				return this.prazo.responsavel.pk || null;
			},
			set(value) {
				if (!this.prazo) return;
				if (value) {
					this.prazo.responsavel = new Usuario({ pk: value });
				} else {
					this.prazo.responsavel = new Usuario({});
				}
			}
		},
		supervisorPk: {
			get() {
				if (!this.prazo || !this.prazo.supervisor) {
					return null;
				}
				return this.prazo.supervisor.pk || null;
			},
			set(value) {
				if (!this.prazo) return;
				if (value) {
					this.prazo.supervisor = new Usuario({ pk: value });
				} else {
					this.prazo.supervisor = new Usuario({});
				}
			}
		},
	},
	methods: {
		async adicionarPrazo() {

			const loadingAdicionarPrazo = this.$vsloading({
				container: "#popup-adicionar-prazo",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});


			try {
				await Prazo.criar(this.prazo, this.empresaPk);

				setTimeout(() => {
					this.popupPrazoAdicionado = true;
					loadingAdicionarPrazo.hide();
				}, 500);
			} catch (error) {

				ErrorHelper.renderFormError("#form-adicionar-prazo", error);
				loadingAdicionarPrazo.hide();
			}
		},
		cancelarCadastro() {
			this.popupCancelarCadastro = false;
			this.activePopup = false;
		},
		cadastroFinalizado() {
			this.popupPrazoAdicionado = false;
			this.activePopup = false;
		},
		funcaoFechar() {
			if (this.closed) {
				this.closed();
			}

			this.prazo = new Prazo({
				responsavel: new Usuario({}),
				supervisor: new Usuario({}),
				partes: [],
				anexos: [],
				ciente: false,
				prioridade: false,
				diasUteis: "false",
			});

			const form = document.querySelector("#form-adicionar-prazo");
			ErrorHelper.cleanFormErrors(form);
		},
		async getEmpresa() {
			const loadingEmpresa = this.$vsloading({
				container: "#popup-adicionar-prazo",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				const empresa = await Empresa.getEmpresa(this.empresaPk);
				this.empresa = empresa;
			} catch (error) {
				console.error(error);
			} finally {
				loadingEmpresa.hide();
			}
		},
		setPrazoCopy() {
			if (!this.prazoCopy) {
				return;
			}

			const {
				responsavel,
				supervisor,
				titulo,
				acao,
				prioridade,
				ciente,
				descricao,
				partes,
				anexos,
			} = this.prazoCopy;

			this.prazo.responsavel = responsavel;
			this.prazo.supervisor = supervisor || new Usuario({});
			this.prazo.titulo = titulo;
			this.prazo.acao = acao;
			this.prazo.prioridade = prioridade;
			this.prazo.ciente = ciente;
			this.prazo.descricao = descricao;
			this.prazo.partes = partes;
			this.prazo.anexos = anexos;
		},
	},
	watch: {
		active() {
			if (this.active) {
				this.getEmpresa();
				this.setPrazoCopy();
			}
		}
	},
};
</script>

<style lang="scss" src="./popup_adicionar_prazo_global.scss"></style>
<style lang="scss" scoped src="./popup_adicionar_prazo.scss"></style>
